import React from 'react';
import map from 'lodash/map';
import isInteger from 'lodash/isInteger';
import HightCharts from 'react-highcharts';
require('highcharts-exporting')(HightCharts.Highcharts);

const config = {
  chart: {
    zoomType: 'x',
  },
  title: {
    text: 'Electronic Piezometer',
  },
  subtitle: {
    text: 'Source: NDS-Cloud',
  },
  yAxis: {
    title: {
      text: 'Pressure (KPA)',
    },
  },

  xAxis: {
    type: 'category',
    labels: {
      step: 12,
      rotation: -45,
    },
  },

  legend: {
    align: 'right',
    verticalAlign: 'middle',
  },
};

const PressureGraph = ({ sensor, pressureData }) => {
  const isWaterLevel = !isInteger(sensor);

  if (isWaterLevel) {
    config.title.text = 'Water level';
    config.yAxis.title.text = 'm.MSL';
  } else {
    config.title.text = 'Electronic Piezometer';
    config.yAxis.title.text = 'Pressure (KPA)';
  }

  const series = [
    {
      name: isWaterLevel ? 'Water level' : `Piezometer - ${sensor}`,
      dashStyle: 'dot',
      data: map(pressureData, (record) => [
        record.time,
        isWaterLevel ? record.head : record.data[`p${sensor}`].value,
      ]),
    },
  ];

  return <HightCharts config={{ ...config, series }} />;
};

export default PressureGraph;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureGraph/PressureGraph.js